import fetch from "auth/FetchInterceptor";

const QuizParticipantsService = {};

const quizParticipantsPrefix = "/quiz-participants";

QuizParticipantsService.getQuizParticipants = async () =>
  await fetch(`${quizParticipantsPrefix}`, {
    method: "GET",
  });

QuizParticipantsService.getQuizParticipantById = async (id) =>
  await fetch(`${quizParticipantsPrefix}/${id}`, {
    method: "GET",
  });

QuizParticipantsService.generateCertificate = async (id) =>
  await fetch(`${quizParticipantsPrefix}/${id}/certificate`, {
    method: "GET",
  });

QuizParticipantsService.deleteQuizParticipant = async (id) =>
  await fetch(`${quizParticipantsPrefix}/${id}`, {
    method: "DELETE",
  });

export default QuizParticipantsService;